module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan3-1-2e9650ddf2a19104105bcadccaa71dc3.webp";